/**
 * Client-side mirror of backend/pitch_script_formatter.py (preview before save).
 */

const HEADER_RE = /^(\d{1,2}):(\d{2})\s*[–—-]\s*(\d{1,2}):(\d{2})\s*\|\s*(.+?)\s*$/gm;

function mmssToSec(mm, ss) {
  return Number(mm) * 60 + Number(ss);
}

function wordCount(text) {
  const m = String(text || '').match(/\S+/g);
  return m ? m.length : 0;
}

function estimateDurationSec(text, wpm = 150) {
  const words = wordCount(text);
  if (words <= 0) return 15;
  return Math.max(10, Math.round((words / Math.max(wpm, 60)) * 60));
}

function segmentDoc({ order, title, timeRangeLabel, startSec, endSec, scriptText }) {
  const body = String(scriptText || '').trim();
  const header = String(timeRangeLabel || title || `Part ${order}`).trim();
  const teleprompter = body ? `${header}\n\n${body}` : header;
  const target = endSec > startSec
    ? Math.max(5, endSec - startSec)
    : estimateDurationSec(body);
  return {
    id: `preview-${order}`,
    order,
    title: title || `Part ${order}`,
    time_range_label: timeRangeLabel || '',
    start_sec: startSec,
    end_sec: endSec > startSec ? endSec : startSec + target,
    target_duration_sec: target,
    script_text: body,
    teleprompter_text: teleprompter,
  };
}

export function parsePitchScriptPreview(raw, { wpm = 150 } = {}) {
  const text = String(raw || '').replace(/\r\n/g, '\n').trim();
  if (!text) return [];

  const matches = [...text.matchAll(new RegExp(HEADER_RE.source, 'gm'))];
  if (matches.length) {
    return matches.map((match, i) => {
      const startSec = mmssToSec(match[1], match[2]);
      const endSec = mmssToSec(match[3], match[4]);
      const title = match[5].trim();
      const bodyStart = match.index + match[0].length;
      const bodyEnd = i + 1 < matches.length ? matches[i + 1].index : text.length;
      const body = text.slice(bodyStart, bodyEnd).trim();
      return segmentDoc({
        order: i + 1,
        title,
        timeRangeLabel: match[0].trim(),
        startSec,
        endSec,
        scriptText: body,
      });
    });
  }

  const blocks = text.split(/\n\s*\n+/).map((b) => b.trim()).filter(Boolean);
  const parts = blocks.length ? blocks : [text];
  let cursor = 0;
  return parts.map((block, i) => {
    const lines = block.split('\n');
    let title = `Part ${i + 1}`;
    let body = block;
    if (/^#{1,3}\s+/.test(lines[0])) {
      title = lines[0].replace(/^#{1,3}\s+/, '').trim();
      body = lines.slice(1).join('\n').trim();
    }
    const dur = estimateDurationSec(body, wpm);
    const seg = segmentDoc({
      order: i + 1,
      title,
      timeRangeLabel: title,
      startSec: cursor,
      endSec: cursor + dur,
      scriptText: body,
    });
    cursor += dur;
    return seg;
  });
}
